/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-unused-vars */
/* eslint-disable react/style-prop-object */
/* eslint-disable react/jsx-props-no-multi-spaces */
/* eslint-disable no-multi-spaces */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable max-len */
import React, { useEffect, useState, useContext, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@material-ui/core';
import styles from '../../styles/Layout.module.css';
import OrderInfoTable from '../../components/tables/ordersInfo/OrderInfoTable';
import Loading from '../../components/loading/Loading';
import routing from '../../service/routes/routing';
import FlashContext from '../../components/contexts/FlashContext';
import api from '../../service/axios/api';
import CreateOrderDetail from './CreateOrderDetail';

import './orderMain.css';

// eslint-disable-next-line react/prop-types
const OrdersInfo = function ({ handleDrawerClose }) {
  const history = useHistory();
  const { t } = useTranslation();
  const { notifyError, notifySuccess } = useContext(FlashContext);
  const [orders, setOrders] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [page, setPage] = useState(1);
  const [msg, setMsg] = useState('Buscando pedidos...');
  const [itens, setItens] = useState({
    label: '25',
    value: 25,
  });
  const [orderBy, setOrderBy] = useState({ label: 'status', value: '' });
  const [loading, setLoading] = useState(false);
  const [status1, setStatus1] = useState({ label: '', value: '' });
  const [product, setProduct] = useState({ label: '', value: '' });
  const [chipData, setChipData] = React.useState([]);

  const [loadingCreate, setLoadingCreate] = useState(false);
  const [openCreate, setOpenCreate] = useState(false);
  const [orderId, setOrderId] = useState(null);
  const [usercnpj, setUsercnpj] = useState('');
  const [nfseNumber, setNfseNumber] = useState(null);
  const [nfseSerie, setNfseSerie] = useState(null);
  const [status, setStatus] = useState(null);
  const [userName, setUserName] = useState('');
  const [userEmail, setUserEmail] = useState('');
  const [userCep, setuserCep] = useState('');
  const [streetName, setStreetName] = useState('');
  const [houseNumber, setHouseNumber] = useState('');
  const [complement, setComplement] = useState(null);
  const [city, setCity] = useState('');
  const [district, setDistrict] = useState('');
  const [state, setState] = useState('');
  const [value, setvalue] = useState(null);
  const [pdf, setPdf] = useState('');
  const [verificationCode, setverificationCode] = useState(null);
  const [dateIssue, setDateIssue] = useState(null);

  const handleCleanCreate = () => {
    setOrderId(null);
    setUsercnpj('');
    setNfseNumber(null);
    setNfseSerie(null);
    setStatus('');
    setUserName('');
    setuserCep('');
    setUserEmail('')

    setStreetName('');
    setHouseNumber('');
    setComplement('');
    setCity('');
    setDistrict('');
    setState('');
    setvalue('');
    setPdf(null);
    setverificationCode('');
    setDateIssue('');
    setOpenCreate(false);
  }

   const handleCreate = async () => {
      const moneyRegex = /^\d+([.,]\d{1,2})?$/;
      if (!value || value.trim().length === 0 || !moneyRegex.test(value)) {
        notifyError('Insira um valor previsto válido');
        return;
      }
      if (!status) {
        notifyError('Informe o Status');
        return;
      }
 
      if (streetName.length === 0) {
        notifyError('Informe o nome da Rua');
        return;
      }

      if (houseNumber.length === 0) {
        notifyError('Informe o número');
        return;
      }
      if (city.length === 0) {
        notifyError('Informe a cidade');
        return;
      }

      if (userEmail.length === 0) {
        notifyError('Informe o email');
        return;
      }

      if (state.length === 0) {
        notifyError('Informe o estado');
        return;
      }
      if (userName.length === 0) {
        notifyError('Informe o nome');
        return;
      }
      if (usercnpj.length === 0 || usercnpj.length !== 14 && usercnpj.length !== 11) {
        notifyError('Informe um CPF/CNPJ válido');
        return;
      }
      if (userCep.length === 0 || userCep.length !== 8) {
        notifyError('Informe um CEP válido');
        return;
      }


       if(!dateIssue){
        notifyError('Informe a data');
        return
       }
  
      setLoadingCreate(true);
      try {
        const cleanValue = value
          .replace(/\./g, '')  
          .replace(',', '.');  
        const response = await api.invoice.createinvoice(
          orderId,
          usercnpj,
          nfseNumber,
          nfseSerie,
          status,
          userName,
          userEmail,
          userCep,
          streetName,
          houseNumber,
          complement,
          city,
          district,
          state,
          value,
          pdf,
          verificationCode,
          dateIssue,

        );
        notifySuccess(response.message);
        handleCleanCreate();
      } catch (error) {
        if (error.problems?.length > 0) {
          error.problems.forEach(err => notifyError(err.msg));
        } else {
          notifyError(error.message);
        }
      } finally {
        setLoadingCreate(false);
      }
    };

  const find = extra => {
    setOrders([]);
    const cancel = new AbortController();
    setMsg('Buscando pedidos...');
    setLoading(true);
    api.order
      .get(
        // search?.current?.value,
        extra,
        chipData,
        status1.value,
        itens.value,
        page,
        orderBy.value,
        product.value,
        cancel,
      )
      .then(res => {
        console.log(res)
        setTotalPages(res.pages);
        setOrders(res.docs);
        setLoading(false);
      })
      .catch(err => {
        setLoading(false);
        console.log(err);
      });
  };
  useEffect(() => {
    find();
  }, [page, itens, status1, orderBy, product]);

  return (
    <div style={{ padding: 30 }} onClick={handleDrawerClose}>
      <Loading open={loading} msg={msg} />
      <div className="col-sm-12" style={{ marginTop: 10 }}>
        <div
          className="col-sm-12"
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <h4 className={styles.textTitle}>{t('OrderInfo.title')}</h4>
          <Button variant='contained' color='primary' onClick={() => setOpenCreate(true)} > Adicionar NF </Button>
        </div>
        <div>
          <OrderInfoTable
            orders={orders}
            totalPages={totalPages}
            page={page}
            setPage={setPage}
            setOrderBy={setOrderBy}
            itens={itens}
            setItens={setItens}
            setStatus1={setStatus}
            product={product}
            setProduct={setProduct}
            chipData={chipData}
            setChipData={setChipData}
            find={find}
          />
        </div>
      </div>
       <CreateOrderDetail
        openCreate={openCreate}
        setOpenCreate={setOpenCreate}
        loadingCreate={loadingCreate}
        handleCreate={handleCreate}
        handleClean={handleCleanCreate}
        orderId={orderId}
        setOrderId={setOrderId}
        usercnpj={usercnpj}
        setUsercnpj={setUsercnpj}
        nfseNumber={nfseNumber}
        setNfseNumber={setNfseNumber}
        nfseSerie={nfseSerie}
        setNfseSerie={setNfseSerie}
        status={status}
        setStatus={setStatus}
        userName={userName}
        setUserName={setUserName}
        setUserEmail={setUserEmail}
        userCep={userCep}
        setuserCep={setuserCep}
        streetName={streetName}
        setStreetName={setStreetName}
        houseNumber={houseNumber}
        setHouseNumber={setHouseNumber}
        complement={complement}
        setComplement={setComplement}
        city={city}
        setCity={setCity}
        district={district}
        setDistrict={setDistrict}
        state={state}
        setState={setState}
        value={value}
        setvalue={setvalue}
        pdf={pdf}
        setPdf={setPdf}
        verificationCode={verificationCode}
        setverificationCode={setverificationCode}
        dateIssue={dateIssue}
        setDateIssue={setDateIssue}
      />
    </div>
  );
};

export default OrdersInfo;
